module.exports = __webpack_public_path__ + "img/entwined.811493a.jpg";